import React, { useContext } from "react";
import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
  Legend,
} from "recharts";
import { ThemeContext } from "../../../../context/ThemeContext";

const RoseChart = ({ roseChartData }) => {
  const theme = useContext(ThemeContext);
  const labelColor = theme === "lite" ? "black" : "white"; // Evaluate the theme
  const data = roseChartData?.direction_data;

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RadarChart outerRadius="90%" data={data}>
        <PolarGrid />
        <PolarAngleAxis
          dataKey="direction"
          tick={{ fill: labelColor, fontSize: 14 }}
        />
        <PolarRadiusAxis
          angle={0}
          domain={[0, 200]}
          tick={{ fill: labelColor, fontSize: 14 }}
        />
        <Radar
          name="Frequency"
          dataKey="value"
          stroke="#8884d8"
          fill="#1057b3"
          fillOpacity={0.6}
        />
        <Tooltip />
        {/* Custom Legend with Color */}
        <Legend
          payload={[
            {
              value: "Wind Direction Frequency",
              type: "square",
              id: "value",
              color: labelColor,
            },
          ]}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default RoseChart;
